import './scss/pages/archive-post.scss';
import { SearchFilters } from './js/front/search-filters';

window.addEventListener( 'DOMContentLoaded', () => {

	const searchFilters = new SearchFilters();
	searchFilters.initSearchfilters();

} );
